import React, { Suspense } from 'react';
import { LucideProps } from 'lucide-react';
import { iconMap, IconName } from '@/utils/iconMap';
import styles from './Icon.module.css';

interface IconProps extends LucideProps {
  name: IconName | string;
  fallback?: React.ReactNode;
}

// Simple fallback component
const IconFallback: React.FC<{ size?: string | number }> = ({ size = 24 }) => (
  <div 
    className={styles.iconLoader} 
    style={{ width: size, height: size }}
    aria-hidden="true"
    title="Icon loading..."
  >
    ?
  </div>
);

// Simple Icon component
export const Icon: React.FC<IconProps> = ({ 
  name, 
  fallback,
  className = '',
  size = 24,
  ...props 
}) => {
  const LazyIcon = iconMap[name as IconName];
  
  if (!LazyIcon) {
    console.warn(`Icon "${name}" not found in iconMap`);
    return <IconFallback size={size} />;
  }
  
  return (
    <Suspense fallback={fallback || <IconFallback size={size} />}>
      <LazyIcon 
        className={`${styles.icon} ${className}`} 
        size={size} 
        {...props} 
      />
    </Suspense>
  );
};

// Re-export specific icon props types for convenience
export type { LucideProps as IconProps } from 'lucide-react';